// extracted by mini-css-extract-plugin
export var numberInputContainer = "_6v-0";
export var startPickingButton = "_6v-1";